/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL_TAGGING = new InjectionToken<string>('API_BASE_URL_TAGGING');

@Injectable()
export class TaggingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_TAGGING) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get contexts
     * @return Returns a list of contexts
     */
    getContexts(): Observable<ContextDto[]> {
        let url_ = this.baseUrl + "/contexts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContexts(<any>response_);
                } catch (e) {
                    return <Observable<ContextDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ContextDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetContexts(response: HttpResponseBase): Observable<ContextDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContextDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContextDto[]>(<any>null);
    }

    /**
     * Get expectations
     * @param contextId (optional) Specifies the context of the expectations. If not specified, it takes the default context
     * @return Returns a list of expectations
     */
    getExpectations(contextId?: number | undefined): Observable<ExpectationTranslatedDto[]> {
        let url_ = this.baseUrl + "/expectations?";
        if (contextId === null)
            throw new Error("The parameter 'contextId' cannot be null.");
        else if (contextId !== undefined)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpectations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpectations(<any>response_);
                } catch (e) {
                    return <Observable<ExpectationTranslatedDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpectationTranslatedDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExpectations(response: HttpResponseBase): Observable<ExpectationTranslatedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpectationTranslatedDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExpectationTranslatedDto[]>(<any>null);
    }

    /**
     * Get work value expectations
     * @param contextId (optional) Specifies the context of the expectations. If not specified, it takes the default context
     * @return Returns a list of work value expectations
     */
    getWorkValueExpectations(contextId?: number | undefined): Observable<ExpectationTranslatedDto[]> {
        let url_ = this.baseUrl + "/expectations/workvalues?";
        if (contextId === null)
            throw new Error("The parameter 'contextId' cannot be null.");
        else if (contextId !== undefined)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkValueExpectations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkValueExpectations(<any>response_);
                } catch (e) {
                    return <Observable<ExpectationTranslatedDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpectationTranslatedDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWorkValueExpectations(response: HttpResponseBase): Observable<ExpectationTranslatedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpectationTranslatedDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExpectationTranslatedDto[]>(<any>null);
    }

    /**
     * Get team role expectations
     * @param contextId (optional) Specifies the context of the expectations. If not specified, it takes the default context
     * @return Returns a list of team role expectations
     */
    getTeamRoleExpectations(contextId?: number | undefined): Observable<ExpectationTranslatedDto[]> {
        let url_ = this.baseUrl + "/expectations/teamroles?";
        if (contextId === null)
            throw new Error("The parameter 'contextId' cannot be null.");
        else if (contextId !== undefined)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamRoleExpectations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamRoleExpectations(<any>response_);
                } catch (e) {
                    return <Observable<ExpectationTranslatedDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpectationTranslatedDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTeamRoleExpectations(response: HttpResponseBase): Observable<ExpectationTranslatedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpectationTranslatedDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExpectationTranslatedDto[]>(<any>null);
    }

    /**
     * Get expectation types
     * @return Returns a list of expectation types
     */
    getExpectationTypes(): Observable<ExpectationTypeTranslatedDto[]> {
        let url_ = this.baseUrl + "/expectationtypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpectationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpectationTypes(<any>response_);
                } catch (e) {
                    return <Observable<ExpectationTypeTranslatedDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpectationTypeTranslatedDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExpectationTypes(response: HttpResponseBase): Observable<ExpectationTypeTranslatedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpectationTypeTranslatedDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExpectationTypeTranslatedDto[]>(<any>null);
    }

    /**
     * Get job scan expectations
     * @return Returns a list of expectation scores ordered by rank (highest score first)
     */
    getJobScanExpectations(id: string): Observable<JobScanExpectationDto[]> {
        let url_ = this.baseUrl + "/jobscans/{id}/expectations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobScanExpectations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobScanExpectations(<any>response_);
                } catch (e) {
                    return <Observable<JobScanExpectationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<JobScanExpectationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetJobScanExpectations(response: HttpResponseBase): Observable<JobScanExpectationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobScanExpectationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobScanExpectationDto[]>(<any>null);
    }

    /**
     * Get job scan expectation report
     * @param id The job scan id
     * @param contextId (optional) Specifies the context of the expectations. If not specified, it takes the default context
     * @return Returns an expectation report
     */
    getJobScanExpectationReport(id: string, contextId?: number | undefined): Observable<JobScanExpectationReportDto> {
        let url_ = this.baseUrl + "/jobscans/{id}/expectations/report?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (contextId === null)
            throw new Error("The parameter 'contextId' cannot be null.");
        else if (contextId !== undefined)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobScanExpectationReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobScanExpectationReport(<any>response_);
                } catch (e) {
                    return <Observable<JobScanExpectationReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<JobScanExpectationReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetJobScanExpectationReport(response: HttpResponseBase): Observable<JobScanExpectationReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobScanExpectationReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobScanExpectationReportDto>(<any>null);
    }

    /**
     * Get job scan expectation report url
     * @param id The job scan id
     * @param language (optional) Two-letter code for the language, eg 'en'
     * @return Returns an expectation report url
     */
    getJobScanExpectationReportUrl(id: string, language?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/jobscans/{id}/expectations/reporturl?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobScanExpectationReportUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobScanExpectationReportUrl(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetJobScanExpectationReportUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Get job scan answers
     * @param id The job scan id
     * @return Success
     */
    getJobScanAnswers(id: string): Observable<AnswerDto[]> {
        let url_ = this.baseUrl + "/jobscans/{id}/answers";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobScanAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobScanAnswers(<any>response_);
                } catch (e) {
                    return <Observable<AnswerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AnswerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetJobScanAnswers(response: HttpResponseBase): Observable<AnswerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnswerDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnswerDto[]>(<any>null);
    }

    /**
     * add job scan answers
     * @param id The job scan id in the url path
     * @param body (optional) A list of answers with question id and answer option id as json in the body
     * @return Success
     */
    putJobScanAnswers(id: string, body?: AnswerDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/jobscans/{id}/answers";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutJobScanAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutJobScanAnswers(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPutJobScanAnswers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Get job scan answer percentage
     * @param id The job scan id
     * @return Success
     */
    getJobScanAnswerPercentage(id: string): Observable<number> {
        let url_ = this.baseUrl + "/jobscans/{id}/answers/percentage";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobScanAnswerPercentage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobScanAnswerPercentage(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetJobScanAnswerPercentage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * Calculate expectations for a job scan
     * @param id The job scan id in the url path
     * @param body (optional) The language in two letter ISO code. For example, for English this is "en".
                The default value is "nl" (Dutch).
     * @return Accepted
     */
    calculateJobScanExpectations(id: string, body?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/jobscans/{id}/expectations/calculate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateJobScanExpectations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateJobScanExpectations(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCalculateJobScanExpectations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Get job scan questions with answer options
     * @param contextId (optional) Specifies the context of the questions and answers. If not specified, it takes the default context
     * @return Returns a list of job scan questions and their answer options
     */
    getJobScanQuestions(contextId?: number | undefined): Observable<QuestionWithAnswerOptionsDto[]> {
        let url_ = this.baseUrl + "/questions/jobscan?";
        if (contextId === null)
            throw new Error("The parameter 'contextId' cannot be null.");
        else if (contextId !== undefined)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobScanQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobScanQuestions(<any>response_);
                } catch (e) {
                    return <Observable<QuestionWithAnswerOptionsDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuestionWithAnswerOptionsDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetJobScanQuestions(response: HttpResponseBase): Observable<QuestionWithAnswerOptionsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionWithAnswerOptionsDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionWithAnswerOptionsDto[]>(<any>null);
    }

    /**
     * Get talent scan questions with answer options
     * @param contextId (optional) Specifies the context of the questions and answers. If not specified, it takes the default context
     * @return Returns a list of talent scan questions and their answer options
     */
    getTalentScanQuestions(contextId?: number | undefined): Observable<QuestionWithAnswerOptionsDto[]> {
        let url_ = this.baseUrl + "/questions/talentscan?";
        if (contextId === null)
            throw new Error("The parameter 'contextId' cannot be null.");
        else if (contextId !== undefined)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTalentScanQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTalentScanQuestions(<any>response_);
                } catch (e) {
                    return <Observable<QuestionWithAnswerOptionsDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuestionWithAnswerOptionsDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTalentScanQuestions(response: HttpResponseBase): Observable<QuestionWithAnswerOptionsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionWithAnswerOptionsDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionWithAnswerOptionsDto[]>(<any>null);
    }

    /**
     * Get question types
     * @return Returns a list of question types
     */
    getQuestionTypes(): Observable<QuestionTypeTranslatedDto[]> {
        let url_ = this.baseUrl + "/questiontypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionTypes(<any>response_);
                } catch (e) {
                    return <Observable<QuestionTypeTranslatedDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuestionTypeTranslatedDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetQuestionTypes(response: HttpResponseBase): Observable<QuestionTypeTranslatedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionTypeTranslatedDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionTypeTranslatedDto[]>(<any>null);
    }

    /**
     * Calculate expectations for a talent scan
     * @param id The talent scan id in the url path
     * @param body (optional) The language in two letter ISO code. For example, for English this is "en".
                The default value is "nl" (Dutch).
     * @return Accepted
     */
    calculateTalentScanExpectations(id: string, body?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/talentscans/{id}/expectations/calculate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateTalentScanExpectations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateTalentScanExpectations(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCalculateTalentScanExpectations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Get talent scan answers
     * @param id The talent scan id
     * @return Success
     */
    getTalentScanAnswers(id: string): Observable<AnswerDto[]> {
        let url_ = this.baseUrl + "/talentscans/{id}/answers";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTalentScanAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTalentScanAnswers(<any>response_);
                } catch (e) {
                    return <Observable<AnswerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AnswerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTalentScanAnswers(response: HttpResponseBase): Observable<AnswerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnswerDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnswerDto[]>(<any>null);
    }

    /**
     * add talent scan answers
     * @param id The talent scan id
     * @param body (optional) A list of answers with question id and answer option id as json in the body
     * @return Success
     */
    putTalentScanAnswers(id: string, body?: AnswerDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/talentscans/{id}/answers";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutTalentScanAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutTalentScanAnswers(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPutTalentScanAnswers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Get talent scan answer percentage
     * @param id The talent scan
     * @return Success
     */
    getTalentScanAnswerPercentage(id: string): Observable<number> {
        let url_ = this.baseUrl + "/talentscans/{id}/answers/percentage";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTalentScanAnswerPercentage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTalentScanAnswerPercentage(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetTalentScanAnswerPercentage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * Get talent scan expectation report
     * @param id The talent scan id
     * @param contextId (optional) Specifies the context of the questions and answers. If not specified, it takes the default context
     * @return Returns a expectation report
     */
    getTalentScanExpectationReport(id: string, contextId?: number | undefined): Observable<TalentScanExpectationReportDto> {
        let url_ = this.baseUrl + "/talentscans/{id}/expectations/report?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (contextId === null)
            throw new Error("The parameter 'contextId' cannot be null.");
        else if (contextId !== undefined)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTalentScanExpectationReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTalentScanExpectationReport(<any>response_);
                } catch (e) {
                    return <Observable<TalentScanExpectationReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TalentScanExpectationReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTalentScanExpectationReport(response: HttpResponseBase): Observable<TalentScanExpectationReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TalentScanExpectationReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TalentScanExpectationReportDto>(<any>null);
    }

    /**
     * Get talent scan expectation report url
     * @param id The talent scan id
     * @param language (optional) Two-letter code for the language, eg 'en'
     * @return Returns an expectation report url
     */
    getTalentScanExpectationReportUrl(id: string, language?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/talentscans/{id}/expectations/reporturl?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTalentScanExpectationReportUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTalentScanExpectationReportUrl(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetTalentScanExpectationReportUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Get talent scan expectations
     * @return Returns a list of expectation scores ordered by rank (highest score first)
     */
    getTalentScanExpectations(id: string): Observable<TalentScanExpectationDto[]> {
        let url_ = this.baseUrl + "/talentscans/{id}/expectations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTalentScanExpectations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTalentScanExpectations(<any>response_);
                } catch (e) {
                    return <Observable<TalentScanExpectationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TalentScanExpectationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTalentScanExpectations(response: HttpResponseBase): Observable<TalentScanExpectationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TalentScanExpectationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TalentScanExpectationDto[]>(<any>null);
    }
}

export class ApiError implements IApiError {
    code?: string;
    description?: string | undefined;

    constructor(data?: IApiError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ApiError {
        data = typeof data === 'object' ? data : {};
        let result = new ApiError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data; 
    }
}

export interface IApiError {
    code?: string;
    description?: string | undefined;
}

export class ValidationError implements IValidationError {
    propertyName?: string | undefined;
    errorMessage?: string | undefined;
    errorCode?: string | undefined;
    validationErrors?: ValidationError[] | undefined;

    constructor(data?: IValidationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.errorMessage = _data["errorMessage"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(ValidationError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationError {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["errorMessage"] = this.errorMessage;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IValidationError {
    propertyName?: string | undefined;
    errorMessage?: string | undefined;
    errorCode?: string | undefined;
    validationErrors?: ValidationError[] | undefined;
}

export class ApiErrorResponse implements IApiErrorResponse {
    apiError?: ApiError | undefined;
    correlationId?: string;
    errorMessage?: string | undefined;
    validationErrors?: ValidationError[] | undefined;
    detail?: string | undefined;

    constructor(data?: IApiErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiError = _data["apiError"] ? ApiError.fromJS(_data["apiError"]) : <any>undefined;
            this.correlationId = _data["correlationId"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(ValidationError.fromJS(item));
            }
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): ApiErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApiErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiError"] = this.apiError ? this.apiError.toJSON() : <any>undefined;
        data["correlationId"] = this.correlationId;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        data["detail"] = this.detail;
        return data; 
    }
}

export interface IApiErrorResponse {
    apiError?: ApiError | undefined;
    correlationId?: string;
    errorMessage?: string | undefined;
    validationErrors?: ValidationError[] | undefined;
    detail?: string | undefined;
}

export class ContextDto implements IContextDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IContextDto {
    id?: number;
    name?: string | undefined;
}

export class Translation implements ITranslation {
    en?: string | undefined;
    nl?: string | undefined;
    fr?: string | undefined;

    constructor(data?: ITranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.en = _data["en"];
            this.nl = _data["nl"];
            this.fr = _data["fr"];
        }
    }

    static fromJS(data: any): Translation {
        data = typeof data === 'object' ? data : {};
        let result = new Translation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["en"] = this.en;
        data["nl"] = this.nl;
        data["fr"] = this.fr;
        return data; 
    }
}

export interface ITranslation {
    en?: string | undefined;
    nl?: string | undefined;
    fr?: string | undefined;
}

export class ExpectationTranslatedDto implements IExpectationTranslatedDto {
    id?: string;
    name?: Translation | undefined;
    jobScanDescription?: Translation | undefined;
    talentScanDescription?: Translation | undefined;
    expectationTypeId?: number;
    iconUrl?: string | undefined;

    constructor(data?: IExpectationTranslatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? Translation.fromJS(_data["name"]) : <any>undefined;
            this.jobScanDescription = _data["jobScanDescription"] ? Translation.fromJS(_data["jobScanDescription"]) : <any>undefined;
            this.talentScanDescription = _data["talentScanDescription"] ? Translation.fromJS(_data["talentScanDescription"]) : <any>undefined;
            this.expectationTypeId = _data["expectationTypeId"];
            this.iconUrl = _data["iconUrl"];
        }
    }

    static fromJS(data: any): ExpectationTranslatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpectationTranslatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["jobScanDescription"] = this.jobScanDescription ? this.jobScanDescription.toJSON() : <any>undefined;
        data["talentScanDescription"] = this.talentScanDescription ? this.talentScanDescription.toJSON() : <any>undefined;
        data["expectationTypeId"] = this.expectationTypeId;
        data["iconUrl"] = this.iconUrl;
        return data; 
    }
}

export interface IExpectationTranslatedDto {
    id?: string;
    name?: Translation | undefined;
    jobScanDescription?: Translation | undefined;
    talentScanDescription?: Translation | undefined;
    expectationTypeId?: number;
    iconUrl?: string | undefined;
}

export class ExpectationTypeTranslatedDto implements IExpectationTypeTranslatedDto {
    id?: number;
    name?: Translation | undefined;

    constructor(data?: IExpectationTypeTranslatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? Translation.fromJS(_data["name"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExpectationTypeTranslatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpectationTypeTranslatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IExpectationTypeTranslatedDto {
    id?: number;
    name?: Translation | undefined;
}

export class JobScanExpectationDto implements IJobScanExpectationDto {
    jobScanId?: string;
    expectationId?: string;
    score?: number;
    outDated?: boolean;
    rank?: number | undefined;
    reportRank?: number | undefined;

    constructor(data?: IJobScanExpectationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobScanId = _data["jobScanId"];
            this.expectationId = _data["expectationId"];
            this.score = _data["score"];
            this.outDated = _data["outDated"];
            this.rank = _data["rank"];
            this.reportRank = _data["reportRank"];
        }
    }

    static fromJS(data: any): JobScanExpectationDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobScanExpectationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobScanId"] = this.jobScanId;
        data["expectationId"] = this.expectationId;
        data["score"] = this.score;
        data["outDated"] = this.outDated;
        data["rank"] = this.rank;
        data["reportRank"] = this.reportRank;
        return data; 
    }
}

export interface IJobScanExpectationDto {
    jobScanId?: string;
    expectationId?: string;
    score?: number;
    outDated?: boolean;
    rank?: number | undefined;
    reportRank?: number | undefined;
}

export class ClusterTranslatedDto implements IClusterTranslatedDto {
    id?: string;
    name?: Translation | undefined;

    constructor(data?: IClusterTranslatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? Translation.fromJS(_data["name"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClusterTranslatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClusterTranslatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IClusterTranslatedDto {
    id?: string;
    name?: Translation | undefined;
}

export class JobScanExpectationReportDto implements IJobScanExpectationReportDto {
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    title?: string | undefined;
    employer?: string | undefined;
    teamRoles?: ExpectationTranslatedDto[] | undefined;
    workValues?: ExpectationTranslatedDto[] | undefined;
    clusters?: ClusterTranslatedDto[] | undefined;

    constructor(data?: IJobScanExpectationReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactFirstName = _data["contactFirstName"];
            this.contactLastName = _data["contactLastName"];
            this.title = _data["title"];
            this.employer = _data["employer"];
            if (Array.isArray(_data["teamRoles"])) {
                this.teamRoles = [] as any;
                for (let item of _data["teamRoles"])
                    this.teamRoles!.push(ExpectationTranslatedDto.fromJS(item));
            }
            if (Array.isArray(_data["workValues"])) {
                this.workValues = [] as any;
                for (let item of _data["workValues"])
                    this.workValues!.push(ExpectationTranslatedDto.fromJS(item));
            }
            if (Array.isArray(_data["clusters"])) {
                this.clusters = [] as any;
                for (let item of _data["clusters"])
                    this.clusters!.push(ClusterTranslatedDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JobScanExpectationReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobScanExpectationReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactFirstName"] = this.contactFirstName;
        data["contactLastName"] = this.contactLastName;
        data["title"] = this.title;
        data["employer"] = this.employer;
        if (Array.isArray(this.teamRoles)) {
            data["teamRoles"] = [];
            for (let item of this.teamRoles)
                data["teamRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.workValues)) {
            data["workValues"] = [];
            for (let item of this.workValues)
                data["workValues"].push(item.toJSON());
        }
        if (Array.isArray(this.clusters)) {
            data["clusters"] = [];
            for (let item of this.clusters)
                data["clusters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IJobScanExpectationReportDto {
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    title?: string | undefined;
    employer?: string | undefined;
    teamRoles?: ExpectationTranslatedDto[] | undefined;
    workValues?: ExpectationTranslatedDto[] | undefined;
    clusters?: ClusterTranslatedDto[] | undefined;
}

export class AnswerDto implements IAnswerDto {
    answerOptionId?: string;
    questionId?: string;

    constructor(data?: IAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answerOptionId = _data["answerOptionId"];
            this.questionId = _data["questionId"];
        }
    }

    static fromJS(data: any): AnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerOptionId"] = this.answerOptionId;
        data["questionId"] = this.questionId;
        return data; 
    }
}

export interface IAnswerDto {
    answerOptionId?: string;
    questionId?: string;
}

export class AnswerOptionTranslatedDto implements IAnswerOptionTranslatedDto {
    id?: string;
    priority?: number;
    description?: Translation | undefined;

    constructor(data?: IAnswerOptionTranslatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.priority = _data["priority"];
            this.description = _data["description"] ? Translation.fromJS(_data["description"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AnswerOptionTranslatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerOptionTranslatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["priority"] = this.priority;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAnswerOptionTranslatedDto {
    id?: string;
    priority?: number;
    description?: Translation | undefined;
}

export class QuestionWithAnswerOptionsDto implements IQuestionWithAnswerOptionsDto {
    id?: string;
    expectationTypeId?: number;
    title?: Translation | undefined;
    description?: Translation | undefined;
    descriptionListItemsTitle?: Translation | undefined;
    descriptionListItems?: Translation[] | undefined;
    priority?: number;
    answerOptions?: AnswerOptionTranslatedDto[] | undefined;

    constructor(data?: IQuestionWithAnswerOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.expectationTypeId = _data["expectationTypeId"];
            this.title = _data["title"] ? Translation.fromJS(_data["title"]) : <any>undefined;
            this.description = _data["description"] ? Translation.fromJS(_data["description"]) : <any>undefined;
            this.descriptionListItemsTitle = _data["descriptionListItemsTitle"] ? Translation.fromJS(_data["descriptionListItemsTitle"]) : <any>undefined;
            if (Array.isArray(_data["descriptionListItems"])) {
                this.descriptionListItems = [] as any;
                for (let item of _data["descriptionListItems"])
                    this.descriptionListItems!.push(Translation.fromJS(item));
            }
            this.priority = _data["priority"];
            if (Array.isArray(_data["answerOptions"])) {
                this.answerOptions = [] as any;
                for (let item of _data["answerOptions"])
                    this.answerOptions!.push(AnswerOptionTranslatedDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionWithAnswerOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionWithAnswerOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expectationTypeId"] = this.expectationTypeId;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["descriptionListItemsTitle"] = this.descriptionListItemsTitle ? this.descriptionListItemsTitle.toJSON() : <any>undefined;
        if (Array.isArray(this.descriptionListItems)) {
            data["descriptionListItems"] = [];
            for (let item of this.descriptionListItems)
                data["descriptionListItems"].push(item.toJSON());
        }
        data["priority"] = this.priority;
        if (Array.isArray(this.answerOptions)) {
            data["answerOptions"] = [];
            for (let item of this.answerOptions)
                data["answerOptions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IQuestionWithAnswerOptionsDto {
    id?: string;
    expectationTypeId?: number;
    title?: Translation | undefined;
    description?: Translation | undefined;
    descriptionListItemsTitle?: Translation | undefined;
    descriptionListItems?: Translation[] | undefined;
    priority?: number;
    answerOptions?: AnswerOptionTranslatedDto[] | undefined;
}

export class QuestionTypeTranslatedDto implements IQuestionTypeTranslatedDto {
    id?: number;
    name?: Translation | undefined;

    constructor(data?: IQuestionTypeTranslatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? Translation.fromJS(_data["name"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuestionTypeTranslatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionTypeTranslatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IQuestionTypeTranslatedDto {
    id?: number;
    name?: Translation | undefined;
}

export class TalentScanExpectationReportDto implements ITalentScanExpectationReportDto {
    name?: string | undefined;
    teamRoles?: ExpectationTranslatedDto[] | undefined;
    workValues?: ExpectationTranslatedDto[] | undefined;
    clusters?: ClusterTranslatedDto[] | undefined;

    constructor(data?: ITalentScanExpectationReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["teamRoles"])) {
                this.teamRoles = [] as any;
                for (let item of _data["teamRoles"])
                    this.teamRoles!.push(ExpectationTranslatedDto.fromJS(item));
            }
            if (Array.isArray(_data["workValues"])) {
                this.workValues = [] as any;
                for (let item of _data["workValues"])
                    this.workValues!.push(ExpectationTranslatedDto.fromJS(item));
            }
            if (Array.isArray(_data["clusters"])) {
                this.clusters = [] as any;
                for (let item of _data["clusters"])
                    this.clusters!.push(ClusterTranslatedDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TalentScanExpectationReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new TalentScanExpectationReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.teamRoles)) {
            data["teamRoles"] = [];
            for (let item of this.teamRoles)
                data["teamRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.workValues)) {
            data["workValues"] = [];
            for (let item of this.workValues)
                data["workValues"].push(item.toJSON());
        }
        if (Array.isArray(this.clusters)) {
            data["clusters"] = [];
            for (let item of this.clusters)
                data["clusters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITalentScanExpectationReportDto {
    name?: string | undefined;
    teamRoles?: ExpectationTranslatedDto[] | undefined;
    workValues?: ExpectationTranslatedDto[] | undefined;
    clusters?: ClusterTranslatedDto[] | undefined;
}

export class TalentScanExpectationDto implements ITalentScanExpectationDto {
    talentScanId?: string;
    expectationId?: string;
    score?: number;
    outDated?: boolean;
    rank?: number | undefined;
    reportRank?: number | undefined;

    constructor(data?: ITalentScanExpectationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.talentScanId = _data["talentScanId"];
            this.expectationId = _data["expectationId"];
            this.score = _data["score"];
            this.outDated = _data["outDated"];
            this.rank = _data["rank"];
            this.reportRank = _data["reportRank"];
        }
    }

    static fromJS(data: any): TalentScanExpectationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TalentScanExpectationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["talentScanId"] = this.talentScanId;
        data["expectationId"] = this.expectationId;
        data["score"] = this.score;
        data["outDated"] = this.outDated;
        data["rank"] = this.rank;
        data["reportRank"] = this.reportRank;
        return data; 
    }
}

export interface ITalentScanExpectationDto {
    talentScanId?: string;
    expectationId?: string;
    score?: number;
    outDated?: boolean;
    rank?: number | undefined;
    reportRank?: number | undefined;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}